<div style="max-height: 92vh; ">
    <button class="close" mat-button (click)="close()">X</button>
<h3 mat-dialog-title>Create or Update group.</h3>
<mat-dialog-content class="change-bg" >
    <mat-spinner style="margin: auto;" *ngIf="showSpinner; else showContent" ></mat-spinner>

    <ng-template #showContent>
        <div *ngIf="type == 'edit' || type == 'new'">
            <form [formGroup]="groupInfo" >
                <mat-form-field appearance="fill">
                    <mat-label>Group Name</mat-label>
                    <input matInput formControlName="name"  required>
                </mat-form-field>
                <br>
                <mat-form-field appearance="fill">
                    <mat-label>Description</mat-label>
                    <input matInput formControlName="description"  >
                </mat-form-field>
                <br>
            </form>
        </div>
        
        <div *ngIf="type == 'add'" class="container-div">
            <mat-form-field>
                <input matInput type="text" placeholder="Search" [(ngModel)]="searchText" (ngModelChange)="mychange($event)" autocomplete="off">
                <button mat-button matSuffix mat-icon-button>
                  <mat-icon>search</mat-icon>
                </button>
            </mat-form-field>

            <div class="example-container-group mat-elevation-z8">
                <div class="cont-header">Selected Members</div>
                <mat-table [dataSource]="tabledataSelected" (scroll)="onTableScroll($event)">

                    <ng-container matColumnDef="boardmember_name">
                      <mat-cell *matCellDef="let element"> {{element.boardmember_name | titlecase}} {{element.last_name}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="division">
                        <mat-cell *matCellDef="let element"> {{element.division | titlecase}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="id">
                      <mat-cell *matCellDef="let element"> <mat-icon (click)="removebmFromGroup(element.id)">delete</mat-icon> </mat-cell>
                    </ng-container>

                    <mat-row *matRowDef="let row; columns: displayedColumns; let i= index" (click)="selectedRow(row)"
                    [ngClass]="{'highlightTableColor': selectedRowIndex == i}"></mat-row>
                </mat-table>
            </div><br>

            <div class="example-container-group mat-elevation-z8">
                <div class="cont-header">Memberes To Add</div>
                <mat-table [dataSource]="tabledataSuggested" (scroll)="onTableScrollSuggested($event)" >

                    <ng-container matColumnDef="name">
                      <mat-cell *matCellDef="let element"> {{element.name | titlecase}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="division">
                        <mat-cell *matCellDef="let element"> {{element.division | titlecase}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="id">
                      <mat-cell *matCellDef="let element"> <mat-icon (click)="addToTheGroup(element)">add</mat-icon> </mat-cell>
                    </ng-container>

                    <mat-row *matRowDef="let row; columns: displayedColumnsSuggested; let i= index" (click)="selectedRow(row)"
                    [ngClass]="{'highlightTableColor': selectedRowIndex == i}"></mat-row>
                </mat-table>
            </div><br>
            
        </div>
    </ng-template>
    
    
   
</mat-dialog-content>

<mat-dialog-actions *ngIf="type == 'edit' || type == 'new'">
    <div >
        <button class="mat-raised-button mat-primary"(click)="save()">Save</button>
    </div>
    
</mat-dialog-actions>
</div>
